import SubscriptionLayout from "./SubscriptionLayout";
import { appointmentRoutes } from "./modules/appointments/routes";
import { collectionRoutes } from "./modules/collections/routes";
import { couponRoutes } from "./modules/coupons/routes";
import { labelRoutes } from "./modules/label/routes";
import { packageRoutes } from "./modules/packages/routes";
import { providerRoutes } from "./modules/providers/routes";
import { ratingsRoutes } from "./modules/ratings/routes";
import { receiptRoutes } from "./modules/receipts/routes";
import { recurringRoutes } from "./modules/recurring/routes";
import { requestedPackageRoutes } from "./modules/requested-packages/routes";
import { serviceCategoryRoutes } from "./modules/service-categories/routes";
import { serviceRoutes } from "./modules/services/routes";
import { subscriberRoutes } from "./modules/subscribers/routes";

export const subscriptionRoutes = {
  path: "subscriptions",
  component: SubscriptionLayout,
  children: [
    ...appointmentRoutes(),
    ...collectionRoutes(),
    ...packageRoutes(),
    ...providerRoutes(),
    ...receiptRoutes(),
    ...serviceRoutes(),
    ...serviceCategoryRoutes(),
    ...subscriberRoutes(),
    ...couponRoutes(),
    ...requestedPackageRoutes(),
    ...ratingsRoutes(),
    ...recurringRoutes(),
    ...labelRoutes()
  ]
};
